import RefreshIcon from '@mui/icons-material/Refresh';
import { grey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import { useIfaStore } from '@ifa/store';

export function DashboardRefreshButton() {
    const appStatus = useIfaStore(state => state.app.status);
    const setShouldRefetch = useIfaStore(state => state.table.setShouldRefetch);

    const handleRefresh = () => {
        setShouldRefetch(true);
    };

    return (
        <Button
            variant="outlined"
            aria-label="Refresh results"
            data-cy="refresh-results"
            onClick={handleRefresh}
            disabled={appStatus === 'fetching'}
        >
            <RefreshIcon sx={{ fontSize: '1.15rem', color: grey[700], mr: 1 }} />
            Refresh
        </Button>
    );
}
